/**
 * Logger utility for AdMesh UI SDK
 * Disables all logs in production environment
 */

// Check for production environment
// Supports both Vite (import.meta.env) and standard Node.js (process.env)
let isProduction = false;
try {
  // Check for Vite's import.meta.env (only available in ESM modules)
  if (typeof (globalThis as any).importMeta !== 'undefined' && (globalThis as any).importMeta.env?.PROD) {
    isProduction = true;
  }
} catch (e) {
  // import.meta not available, continue with other checks
}

if (!isProduction) {
  isProduction = 
    (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') ||
    (typeof process !== 'undefined' && process.env.ADMESH_ENV === 'production');
}

export const logger = {
  log: (...args: any[]) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    // Errors are always logged, even in production, as they're critical
    console.error(...args);
  },
  
  info: (...args: any[]) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (!isProduction) {
      console.debug(...args);
    }
  },
};

